@let lines = [0, 1, 2, 3];

<div
  class="c-morph-button"
  [class]="
    [
      state() ? 'c-morph-button__icon--' + state() : '',
      color() ? 'c-morph-button--' + color() : '',
    ].join(' ')
  "
>
  @for (line of lines; track $index) {
    <span></span>
  }
</div>
